/** Human label for a notification audience/focus (e.g. `employer` -> `Employer`). */
export function audienceLabel(audience: string): string {
  if (!audience) return ''
  return audience.charAt(0).toUpperCase() + audience.slice(1).replace(/_/g, ' ')
}
